
function waitForSwiper(trigger) {
  var interval = setInterval(function () {
    if (typeof Swiper != "undefined") {
      clearInterval(interval);
      trigger();
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}
function addScript() {
  var swiperScript = document.createElement("script");
  swiperScript.src =
    "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.0.7/js/swiper.min.js";
  document.getElementsByTagName("head")[0].appendChild(swiperScript);
}


let egswiperTiktok;
const initializeBodyObservationForABT = () => {
  const targetNode = document.body;
  const config = { attributes: true };
  const flkity = Flickity.data(document.querySelector(".product-slideshow"))
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if(targetNode.classList.contains("hw-abt-1-1")){
            loadCustomUGCSlider();
         
        }
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
function loadCustomUGCSlider(){
  document.querySelectorAll(".eg-video-section .swiper-container").forEach((el) => {
    const ugcSlider = el.swiper;
    
    console.log(ugcSlider,"ugcSlider");
    if(ugcSlider){
      ugcSlider.destroy();
    }
  });
  document.querySelectorAll(".eg-trending-swiper").forEach((el) => {
    const swiperWrapper = el.querySelector(".eg-video-section .swiper-container");
    const paginationElement = el.querySelector(".eg-video-section .slider__pagination");
    const nextElement = el.querySelector(".swiper-button-next");
    const prevElement = el.querySelector(".swiper-button-prev");
    egswiperTiktok = new Swiper(swiperWrapper, {
      // Optional parameters
      direction: "horizontal",
      spaceBetween: 20,
      slidesPerView: 4,
      roundLengths: true,
      loop: true,
      arrow: true,
      breakpoints: {
        1199: {
          slidesPerView: 4,
        },
        991: {
          slidesPerView: 3.3,
        },
        800: {
          slidesPerView: 2.6,
          arrow: false,
        },
        500: {
          slidesPerView: 1.2,
        },
        320: {
          slidesPerView: 1.2,
        },
      },
      pagination: {
        el: paginationElement,
        clickable: true,
      },
      navigation: {
        nextEl: nextElement,
        prevEl: prevElement,
      },
    });
  });
  
   //window.dispatchEvent(new Event("resize"))
}
document.addEventListener('DOMContentLoaded', (event) => {
  if (typeof Swiper == "undefined") {
    addScript();
  }
  waitForSwiper(function () {
    loadCustomUGCSlider();
  });
  initializeBodyObservationForABT();
});
document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelectorAll(".eg-trending-swiper").length > 0){
    const videoSlider = document.querySelector('.tiktok-video-slider-section');
    const productDescription = document?.querySelector('.product__description');
    const mainElement = document.querySelector("section.page-width.section--padding");

    function handleVideoSlider() {
        if (window.innerWidth < 576) {
          mainElement.classList.add("no-custom-padding");
            // Check if the video slider is not already cloned
            if (!productDescription.querySelector('.cloned-video-slider')) {
                const clonedSlider = videoSlider.cloneNode(true);
                clonedSlider.classList.add('cloned-video-slider'); // Add a class to identify the cloned element
                productDescription.appendChild(clonedSlider);
                
                // Initialize video events for the cloned slider
                initlizeCustomEvents();

                // Ensure the Swiper is initialized for the cloned slider
              waitForSwiper(function () {
                loadCustomUGCSlider();
              });
               
            }
            videoSlider.style.display = 'none'; // Hide original video section
        } else {
           mainElement.classList.remove("no-custom-padding");
            videoSlider.style.display = 'block'; // Show original section on larger screens

            // Remove cloned section if it exists
            const clonedSlider = productDescription?.querySelector('.cloned-video-slider');
            if (clonedSlider) {
                clonedSlider.remove();
               waitForSwiper(function () {
                loadCustomUGCSlider();
              });
            }
        }
    }

    // Initial check on page load
    handleVideoSlider();

    // Add resize event listener
    window.addEventListener('resize', handleVideoSlider);
  }
    
});